import React from "react";

interface IconButtonProps {
    icon: React.ReactNode;
    ariaLabel: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    title?: string;
    className?: string;
    size?: "sm" | "md";
    tabIndex?: number;
}

const SIZE_CLASSES: Record<"sm" | "md", string> = {
    sm: "p-0.5 rounded text-gray-500 hover:bg-gray-300 hover:text-gray-800 disabled:hover:text-gray-500",
    md: "p-2 rounded-full hover:bg-gray-100",
};

const IconButton: React.FC<IconButtonProps> = (
    {
        icon,
        ariaLabel,
        onClick,
        disabled = false,
        title,
        className = "",
        size = "md",
        tabIndex,
    }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
            title={title}
            tabIndex={tabIndex}
            className={`inline-flex items-center justify-center cursor-pointer transition-colors disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent ${SIZE_CLASSES[size]} ${className}`}
        >
            {icon}
        </button>
    );
};

export default IconButton;
